import { useEffect } from "react";
import { Form, Row, Col, Select, InputNumber, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";

export default function DayCountCalendarRulesForm({
  onFinish,
  initialValues,
  form,
  holidayCalendarOptions,
  businessDayAdjustmentOptions,
  settlementDateTypes,
  dayCountConventionOptions,
  interestCalculationBasisOptions,
  maturityAdjustmentRule,
}) {
  useEffect(() => {
    if (initialValues) form.setFieldsValue(initialValues);
  }, [initialValues, form]);

  return (
    <div>
      <h3 style={{ marginBottom: 24, fontWeight: 600 }}>
        Day Count & Calendar Rules
      </h3>

      <Form layout="vertical" form={form} onFinish={onFinish}>
        {/* Day Count & Business Day Convention */}
        <Row>
          <Col span={12} style={{ padding: "0 8px" }}>
            <Form.Item
              label={
                <span>
                  Day Count Convention
                  <Tooltip title="Determines how time fractions are calculated for accruals, interest, and yield computations.">
                    <InfoCircleOutlined
                      style={{ marginLeft: 4, color: "#667085" }}
                    />
                  </Tooltip>
                </span>
              }
              name="dayCountConvention"
              rules={[{ required: true }]}
            >
              <Select
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" />}
                options={interestCalculationBasisOptions}
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0 8px" }}>
            <Form.Item
              label={
                <span>
                  Business Day Convention
                  <Tooltip title="Defines how dates falling on non-business days are adjusted.">
                    <InfoCircleOutlined
                      style={{ marginLeft: 4, color: "#667085" }}
                    />
                  </Tooltip>
                </span>
              }
              name="businessDayConvention"
              rules={[{ required: true }]}
            >
              <Select
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" />}
                options={businessDayAdjustmentOptions}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Holiday Calendar & Settlement Days */}
        <Row>
          <Col span={12} style={{ padding: "0 8px" }}>
            <Form.Item
              label={
                <span>
                  Holiday Calendar
                  <Tooltip title="Validates settlement, coupon, and maturity dates against applicable holidays.">
                    <InfoCircleOutlined
                      style={{ marginLeft: 4, color: "#667085" }}
                    />
                  </Tooltip>
                </span>
              }
              name="holidayCalendarCode"
              rules={[{ required: true }]}
            >
              <Select
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" />}
                options={holidayCalendarOptions}
                onChange={(value, option) => {
                  // 👇 store ID alongside code
                  form.setFieldsValue({
                    holidayCalendarId: option.id,
                  });
                }}
              />
            </Form.Item>

            <Form.Item name="holidayCalendarId" hidden>
              <InputNumber />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0 8px" }}>
            <Form.Item
              label={
                <span>
                  Settlement Days
                  <Tooltip title="Determines settlement date generation from trade date (T+0, T+1, T+2).">
                    <InfoCircleOutlined
                      style={{ marginLeft: 4, color: "#667085" }}
                    />
                  </Tooltip>
                </span>
              }
              name="settlementDays"
              rules={[{ required: true }]}
            >
              <Select
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" />}
                options={settlementDateTypes}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Maturity Adjustment */}
        <Row>
          <Col span={12} style={{ padding: "0 8px" }}>
            <Form.Item
              label={
                <span>
                  Maturity Adjustment Rule
                  <Tooltip title="Controls whether maturity processing is shifted when maturity falls on a non-business day.">
                    <InfoCircleOutlined
                      style={{ marginLeft: 4, color: "#667085" }}
                    />
                  </Tooltip>
                </span>
              }
              name="maturityAdjustmentRule"
              rules={[{ required: true }]}
            >
              <Select
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" />}
                options={maturityAdjustmentRule}
              />
            </Form.Item>
          </Col>
        </Row>

        <button type="submit" hidden />
      </Form>
    </div>
  );
}
